/**
 * @class
 * @description This class connect to cdn the cdb balancer api and hepls to get data
 * @exports PingTimeBean
 */
export default class StatsBean {
    constructor(profile_name, provider, downloaded_bytes, downloaded_chunks, errors, time, max_bandwidth, min_bandwidth, banned, unbanned, avg_ping_time, min_ping_time, max_ping_time, is_banned, is_active, resource) {
        this.profile_name = profile_name;
        this.provider = provider;
        this.downloaded_bytes = downloaded_bytes;
        this.downloaded_chunks = downloaded_chunks;
        this.errors = errors;
        this.time = time;
        this.max_bandwidth = max_bandwidth;
        this.min_bandwidth = min_bandwidth;
        this.banned = banned;
        this.unbanned = unbanned;
        this.avg_ping_time = avg_ping_time;
        this.min_ping_time = min_ping_time;
        this.max_ping_time = max_ping_time;
        this.is_banned = is_banned;
        this.is_active = is_active;
        this.resource = resource;
    }
}
